export const COOKIE_DOMAIN: string | null =
  import.meta.env.VITE_APP_ENV === 'staging'
    ? '.webcatalog.dev'
    : import.meta.env.VITE_APP_ENV === 'local'
      ? null
      : '.webcatalog.io';
